import { Anchor, Flex, Space, Text } from "@mantine/core";
import {
  Fonts,
  footerBusinessLinks,
  footerQuickLinks,
  footerSocialLinks
} from "../../models";

export function Footer() {
  return (
    <Flex
      justify={"space-between"}
      w={"100%"}
      style={{
        borderTop: "1px solid #ececec",
        fontFamily: Fonts.INTER,
        position: "sticky",
      }}
      px={"10%"}
      py={"5%"}
      wrap={"wrap"}
      bg={"#ffffff"}
    >
      <Flex direction={"column"} m={15}>
        <Text fw={"bold"} size="lg">
          Quick Links
        </Text>
        <Space h={30} />
        {footerQuickLinks.map((item) => (
          <Anchor
            key={item.href}
            href={item.href}
            target="_blank"
            underline="hover"
            c={"black"}
            mb={8}
          >
            {item.title}
          </Anchor>
        ))}
      </Flex>
      <Flex direction={"column"} m={15}>
        <Text fw={"bold"} size="lg">
          Business Links
        </Text>
        <Space h={30} />
        {footerBusinessLinks.map((item) => (
          <Anchor
            key={item.href}
            href={item.href}
            target="_blank"
            underline="hover"
            c={"black"}
            mb={8}
          >
            {item.title}
          </Anchor>
        ))}
      </Flex>
      <Flex direction={"column"} m={15}>
        <Text fw={"bold"} size="lg">
          Social
        </Text>
        <Space h={30} />
        {footerSocialLinks.map((item) => (
          <Flex key={item.title}>
            <item.icon />
            <Space w={10} />
            <Anchor
              href={item.href}
              target="_blank"
              underline="hover"
              c={"black"}
              mb={8}
            >
              {item.title}
            </Anchor>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
